import { render, staticRenderFns } from "./bridgeProfileForm.vue?vue&type=template&id=c712ff66&scoped=true&"
import script from "./bridgeProfileForm.vue?vue&type=script&lang=js&"
export * from "./bridgeProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./bridgeProfileForm.vue?vue&type=style&index=0&id=c712ff66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c712ff66",
  null
  
)

export default component.exports